import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import EmailTemplateForm from 'pages/app/emailtemplates/smartviews/EmailTemplateForm'
import ConfirmFormChanges from 'support/pipelines/ConfirmFormChanges'
import { ExecuteOperationOnPipe, ModelWithForm } from '@morningtrain/react-resources'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import { ResetSmartviewOnPipe } from '@morningtrain/react-smartviews'

export default function EditEmailTemplateSmartview ({ id }) {
  const footer = (
    <UI.ButtonWrap>
      <DeleteModelOnClick
        resourceName='email_templates'
        pipes={(
          <>
            <ExecuteOperationOnPipe namespace='api' resourceName='email_templates' operationName='index' />
            <ResetSmartviewOnPipe />
          </>
        )}
      >
        <UI.DeleteButton big />
      </DeleteModelOnClick>
      <UI.SubmitButton>
        <Translation name='generic.save' />
      </UI.SubmitButton>
    </UI.ButtonWrap>
  )

  return (
    <Translator namespace='email_templates'>
      <ModelWithForm resourceName='email_templates' id={id}>
        <Smartview size='2xl' footer={footer} header={<Translation name='titles.edit' />}>
          <ExecuteOperationOnPipe namespace='api' resourceName='email_templates' operationName='index' />
          <ConfirmFormChanges />
          <EmailTemplateForm />
        </Smartview>
      </ModelWithForm>
    </Translator>
  )
}
